import styles from './Footer.module.scss';

function Footer(): JSX.Element {
  return <div className={styles.Footer}>© {new Date().getFullYear()} EP+Co</div>;
}

export default Footer;
